<script lang="ts">
    import type { JsonLinkNode } from '../../jsonNode';
    import LinkButton from '../LinkButton.svelte';
    export let value: JsonLinkNode;
</script>

<template>
    <LinkButton {value} />
</template>
